/// <reference types="./vite-env.d.ts" />

import { useState, useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { fetchSettings, fetchMyIp } from "./services/api";
import MaintenancePage from "./pages/maintenance/page";
import "./App.css";

// Get base path from Vite config - defaults to "/" if not set
// @ts-ignore - __BASE_PATH__ is defined in vite.config.ts
let basePath = '/';
try {
  basePath = __BASE_PATH__;
} catch {
  // Fallback to root if __BASE_PATH__ is not defined
  basePath = '/';
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function MaintenanceGate() {
  const location = useLocation();
  const [maintenanceMode, setMaintenanceMode] = useState<boolean | null>(null);
  const [ipWhitelisted, setIpWhitelisted] = useState(false);

  useEffect(() => {
    Promise.all([fetchSettings(), fetchMyIp()]).then(([settings, myIp]) => {
      const setting = settings.find((s) => s.key === 'maintenance_mode');
      setMaintenanceMode(setting?.value === 'true');

      const whitelistSetting = settings.find((s) => s.key === 'maintenance_whitelist_ips');
      if (whitelistSetting && myIp) {
        const whitelist = whitelistSetting.value
          .split(',')
          .map((ip) => ip.trim())
          .filter(Boolean);
        setIpWhitelisted(whitelist.includes(myIp));
      }
    });
  }, []);

  // Show dark background while loading to prevent white flash
  if (maintenanceMode === null) {
    return <div className="min-h-screen bg-[#0A0E27]" />;
  }

  // Admin routes always bypass maintenance mode
  const isAdminRoute = location.pathname.startsWith('/admin');

  if (maintenanceMode && !isAdminRoute && !ipWhitelisted) {
    return <MaintenancePage />;
  }

  return <AppRoutes />;
}

function App() {
  return (
    <HelmetProvider>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter basename={basePath}>
          <ScrollToTop />
          <MaintenanceGate />
        </BrowserRouter>
      </I18nextProvider>
    </HelmetProvider>
  );
}

export default App;
